import { useState } from "react";
import { Button, Card, DatePicker, Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { ORIGINS, STATUS_DATE_LABELS, STATUS_FILTERS } from "../constants";

export function PedidoFilters({
  origin,
  setOrigin,
  status,
  setStatus,
  statusDate,
  setStatusDate,
  search,
  setSearch,
  hasActiveFilters,
  onClear,
}) {
  // Rascunho do campo: a busca só vai para a API no Enter ou ao limpar.
  const [searchInput, setSearchInput] = useState(search);

  const dateLabel = status
    ? STATUS_DATE_LABELS[status] || "Data do status"
    : "Data de criação";

  return (
    <Card className="te-card te-filters-card">
      <div style={{ marginBottom: 18 }}>
        <h3 style={{ margin: 0, color: "var(--te-primary)" }}>Filtros</h3>
        <p className="te-kicker">
          Busque por número do pedido, cliente, e-mail, locker ou reserva.
        </p>
      </div>

      <div className="te-form-grid te-form-grid--compact te-filters-grid">
        <div>
          <label className="te-label">Origem</label>
          <Select
            style={{ width: "100%" }}
            size="large"
            value={origin}
            onChange={setOrigin}
            options={ORIGINS}
          />
        </div>

        <div>
          <label className="te-label">Status</label>
          <Select
            style={{ width: "100%" }}
            size="large"
            value={status}
            onChange={setStatus}
            options={STATUS_FILTERS}
          />
        </div>

        <div>
          <label className="te-label">{dateLabel}</label>
          <DatePicker
            style={{ width: "100%" }}
            size="large"
            value={statusDate}
            onChange={setStatusDate}
            format="DD/MM/YYYY"
            placeholder={status ? "Filtrar por dia" : "Data de criação"}
            allowClear
          />
        </div>

        <div className="te-filters-search">
          <label className="te-label">Busca</label>
          <Input
            size="large"
            allowClear
            prefix={<SearchOutlined style={{ color: "var(--te-text-muted)" }} />}
            value={searchInput}
            onChange={(event) => {
              setSearchInput(event.target.value);
              if (!event.target.value) setSearch("");
            }}
            onPressEnter={() => setSearch(searchInput.trim())}
            placeholder="Buscar por nº do pedido, cliente, e-mail ou locker"
          />
        </div>

        {hasActiveFilters ? (
          <div className="te-form-action te-filters-action">
            <Button
              onClick={() => {
                setSearchInput("");
                onClear();
              }}
            >
              Limpar filtros
            </Button>
          </div>
        ) : null}
      </div>
    </Card>
  );
}
